import { Component, Input, OnInit } from '@angular/core';
import { TreeviewBase } from './../treeview.base';
import { TreeViewSingleData } from '../../models/tree-view-single-data';
import { CheckboxTreeviewComponent } from '../checkbox-treeview/checkbox-treeview.component';

@Component({
    selector: 'treeview-single',
    template: `
        @if (treeViewData) {
          <checkbox-treeview
            [treeviewData]="treeViewData.items"
            [showFilter]="showFilter"
            [showOnlyFilter]="showOnlyFilter"
            [showParentsInFilter]="showParentsInFilter"
            (selectedChange)="onSelectedChange($event)">
          </checkbox-treeview>
        }
        `,
    imports: [CheckboxTreeviewComponent]
})
export class TreeviewSingleComponent extends TreeviewBase {

    @Input() declare treeViewData: TreeViewSingleData;
    @Input() showFilter?: boolean = false;
    @Input() showOnlyFilter?: boolean = false;
    @Input() showParentsInFilter?: boolean = true;
    @Input() maxHeight?: number = 350;

    constructor() { 
        super(); 
    }

}